module.exports = __webpack_public_path__ + "static/media/liebherr160.56f406ad.pdf";